module.exports = __webpack_public_path__ + "9b7a06626d2a999b5ffb6025fb0623ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 332
// module chunks = 0